import * as z from "zod/v4";
import { calendarEntry } from "./calendar-entry";

export const listCalendarEntries = {
  name: "listCalendarEntries" as const,
  input: z.object({ rangeStart: z.date(), rangeEnd: z.date() }),
  output: z.object({ entries: z.array(calendarEntry) }),
};
